<script>
import {h} from 'vue';
import {cardCustomCss} from './renderCustomDesign.js';

export default {
    name: 'CustomDesignAnimation',
    props: {section: {type: Object, required: true}, animationName: {type: String, required: true}},
    render() {
        const css = cardCustomCss(this.section, this.animationName);
        return css ? h('style', css) : null;
    }
};
</script>
